import { render, staticRenderFns } from "./AmenitiesList.vue?vue&type=template&id=8fd6db0a&"
import script from "./AmenitiesList.vue?vue&type=script&lang=js&"
export * from "./AmenitiesList.vue?vue&type=script&lang=js&"
import style0 from "./AmenitiesList.vue?vue&type=style&index=0&id=8fd6db0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports